import { MapPin, Navigation, Settings } from "lucide-react";
import { C } from "./data";
import { Serif } from "./ui";

export default function LocationPrimer({ variant = "primer", onEnable, onClose }) {
  const denied = variant === "denied";
  const accent = denied ? C.amber : C.red;
  return (
    <div data-testid="location-primer" style={{ position: "absolute", inset: 0, zIndex: 55, background: "rgba(11,30,59,0.82)", backdropFilter: "blur(4px)", display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: 20 }}>
      <div style={{ background: C.body, borderRadius: 20, padding: "26px 22px 22px", boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
        <div style={{ width: 52, height: 52, borderRadius: 14, background: `${accent}14`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          {denied ? <Settings size={26} color={accent} /> : <MapPin size={26} color={accent} />}
        </div>
        <Serif size={23} style={{ marginBottom: 8 }}>{denied ? "Location is blocked" : "Allow location access"}</Serif>
        <div style={{ fontSize: 14, color: C.slate, lineHeight: 1.55, marginBottom: 22 }}>
          {denied
            ? "Your browser is currently blocking location for ResQ1. Open your browser's site settings for this page, set Location to \u201CAllow\u201D, then come back and try again."
            : "We use your location only to send responders straight to you in an emergency and to share your live position with family when you choose to. It's never sold or shared with anyone else."}
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} data-testid="location-primer-close"
            style={{ flex: "0 0 auto", padding: "12px 18px", background: "transparent", color: C.slate, border: "1px solid rgba(26,30,36,0.15)", borderRadius: 999, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            {denied ? "Close" : "Not now"}
          </button>
          {!denied && (
            <button onClick={onEnable} data-testid="location-primer-enable"
              style={{ flex: 1, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, padding: 12, background: C.red, color: "#fff", border: 0, borderRadius: 999, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              <Navigation size={16} /> Enable location
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
